import { type UseMutationResult } from "@tanstack/react-query";
import { useApiMutation, type UseApiMutationOptions } from "./useApiMutation.ts";

export type UseDeferrableMutationOptions<TData, TVariables> = Omit<
  UseApiMutationOptions<TData, TVariables>,
  "confirmViaWebSocket" | "offlineCapable" | "operationLabel"
> & { operationLabel: string };

// Choosing this hook asserts that a late write cannot overwrite something newer.
export function useDeferrableMutation<TData = unknown, TVariables extends object = object>(
  options: UseDeferrableMutationOptions<TData, TVariables>,
): UseMutationResult<TData, Error, TVariables> {
  return useApiMutation<TData, TVariables>({
    ...options,
    confirmViaWebSocket: true,
    offlineCapable: true,
  });
}
